<div class="insight-legend">
    <button
        class="btn bg-transparent insight-pop-up-open"
        tabIndex="-1"
        [cmpsOverlayTrigger]="filterTpl"
        placement="left-top"
    >
        {{ _i18n._7391_LEGEND | translate }}
    </button>
    <ng-template
        let-overlay="overlay"
        #filterTpl
    >
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 insight-pop-up-frame insight-legend"
        >
            <div class="d-flex align-items-center">
                <div class="col flex-grow-1 cmps-cdk-font-bold">
                    {{ _i18n._7391_LEGEND | translate }}
                </div>
                <button
                    class="btn bg-transparent"
                    tabIndex="-1"
                    (click)="overlay?.toggle()"
                >
                    <cmps-icon
                        class="cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400"
                        svgIcon="close"
                    ></cmps-icon>
                </button>
            </div>

            <div
                class="insight-legend insight-pop-up-content insight-scrollable"
            >
                <table class="bordered">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th colSpan="3">
                                {{
                                    _i18n._7147_NEGATIVE_PERFORMANCE | translate
                                }}
                            </th>
                            <th colSpan="3">
                                {{
                                    _i18n._7148_POSITIVE_PERFORMANCE | translate
                                }}
                            </th>
                        </tr>
                        <tr>
                            <th>
                                {{ _i18n._7146_METRIC_NAME | translate }}
                            </th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 3</th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 2</th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 1</th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 1</th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 2</th>
                            <th>{{ _i18n._7149_THRESHOLD | translate }} 3</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of metricThresholds">
                            <tr>
                                <td>{{ item.metricShortName }}</td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.neg3Colour
                                            : null
                                    "
                                >
                                    {{ item.neg3Value }}
                                </td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.neg2Colour
                                            : null
                                    "
                                >
                                    {{ item.neg2Value }}
                                </td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.neg1Colour
                                            : null
                                    "
                                >
                                    {{ item.neg1Value }}
                                </td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.pos1Colour
                                            : null
                                    "
                                >
                                    {{ item.pos1Value }}
                                </td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.pos2Colour
                                            : null
                                    "
                                >
                                    {{ item.pos2Value }}
                                </td>
                                <td
                                    [style.color]="
                                        showThresholdColours === true
                                            ? item.pos3Colour
                                            : null
                                    "
                                >
                                    {{ item.pos3Value }}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <br />
                <table
                    class="bordered"
                    *ngIf="showTrendArrows === true"
                >
                    <thead>
                        <tr class="bordered">
                            <th>
                                {{ _i18n._989_TREND | translate }}
                            </th>
                            <th>
                                {{ _i18n._7150_IMAGE | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of trends">
                            <tr>
                                <td>{{ item.trendName }}</td>
                                <td>
                                    <cmps-icon
                                        [style.fill]="
                                            item.trendClass.split(' ')[0]
                                        "
                                        [svgIcon]="
                                            item.trendClass
                                                .split(' ')[1]
                                                .toLowerCase()
                                                .includes('up')
                                                ? 'chevron-up'
                                                : item.trendClass
                                                      .split(' ')[1]
                                                      .toLowerCase()
                                                      .includes('down')
                                                ? 'chevron-down'
                                                : null
                                        "
                                        *ngIf="
                                            item.trendClass?.split(' ')
                                                ?.length > 1
                                        "
                                    ></cmps-icon>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>
</div>
